export const TYPES = {
  SELECT_GROUP_SERVICE_SUCCESS: "group/SELECT_GROUP_SERVICE_SUCCESS",
};
